import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"

export default class extends Controller {
  static values = { updateUrl: String }
  static targets = ["badge"]

  markAsRead(event) {
    event.preventDefault()

    patch(this.updateUrlValue, {
      responseKind: "turbo-stream"
    }).then((response) => {
      if (response.ok) {
        this.decrementBadge()
        if (window.location.pathname === '/notifications') {
          window.location.reload()
        }
      }
    })
  }

  markAllAsRead(event) {
    event.preventDefault()

    fetch('/notifications/mark_all_as_read', {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        this.hideBadge()
        this.reloadNotifications()
      }
    })
  }

  decrementBadge() {
    if (!this.hasBadgeTarget) return

    const currentCount = parseInt(this.badgeTarget.textContent)
    const newCount = Math.max(0, currentCount - 1)

    if (newCount === 0) {
      this.hideBadge()
    } else {
      this.badgeTarget.textContent = newCount > 9 ? '9+' : newCount
    }
  }

  hideBadge() {
    if (this.hasBadgeTarget) {
      this.badgeTarget.style.display = 'none'
    }
  }

  reloadNotifications() {
    const turboFrame = document.querySelector('#notifications-dropdown')
    if (turboFrame) {
      turboFrame.src = '/notifications?format=turbo_stream'
      turboFrame.reload()
    }
  }
}
